import { render, staticRenderFns } from "./thankyou.vue?vue&type=template&id=2abbcbc2&scoped=true"
import script from "./thankyou.vue?vue&type=script&lang=js"
export * from "./thankyou.vue?vue&type=script&lang=js"
import style0 from "./thankyou.vue?vue&type=style&index=0&id=2abbcbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abbcbc2",
  null
  
)

export default component.exports